import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";

import Video from "../Video";

export default function LandingSobre(){

	return (
		<Container fluid id="sobre" className="d-flex justify-content-center py-5 position-relative" style={{overflowX: 'clip'}}>
			<Container>
				<div className="mb-5 fs-1 text-white fw-bold text-center">Sem mensalidades, com parceria e confiança.<br/>Conheça a Tribo Barber!</div>
				<Row>
					<Col className="justify-content-center align-items-center position-relative" style={{zIndex: 1}}>
						<div className="position-absolute d-flex justify-content-between align-items-center" style={{inset: 0, zIndex: -1}}>
							<motion.img initial={{x: -200}} whileInView={{x: -100}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} src="icon-transparent-inverted.png" alt="Logo Tribo Barber" style={{opacity: 0.1, objectFit: 'contain', maxWidth: "50%", height: "100%"}}/>
							<motion.img initial={{x: 200}} whileInView={{x: 100}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}} src="icon-transparent.png" alt="Logo Tribo Barber" style={{opacity: 0.1, objectFit: 'contain', maxWidth: "50%", height: "100%"}}/>
						</div>
						<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}}>
							<Video video={process.env.PUBLIC_URL+"videos/video.mp4"} />
						</motion.div>
					</Col>
				</Row>
			</Container>
		</Container>
	)
}